import { render, staticRenderFns } from "./close_performance_sale.vue?vue&type=template&id=68fb1b2c&scoped=true&"
import script from "./close_performance_sale.vue?vue&type=script&lang=js&"
export * from "./close_performance_sale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fb1b2c",
  null
  
)

export default component.exports